module.exports = __webpack_public_path__ + "img/teams.e87b930e.png";